<template>
  <div class="app">
    <Card dis-hover>
      <Form
        :model="query"
        :label-width="90"
        label-position="right"
        style="margin: 10px"
      >
        <Row :gutter="16">
          <Col span="8">
          <FormItem label="供应商名称：">
            <Select
                placeholder="请输入供应商名称"
                v-model="supplierNameList"
                multiple
                filterable
                :remote-method="remoteMethod"
                :loading="loading2">
                <Option v-for="(option, index) in options2" :value="option.value" :key="index">{{option.label}}</Option>
            </Select>
            </FormItem>
          </Col>
          <!-- <Col span="8">
            <FormItem label="供应商名称：">
              <Input v-model="query.SupplierName" placeholder="请输入供应商名称" ></Input>
            </FormItem>
          </Col> -->
          <Col span="6">
            <FormItem label="受单日期:" style="width: 100%">
              <DatePicker v-model="rangeTimeSDRQ" type="daterange" format="yyyy-MM-dd" style="width: 100%" placement="bottom-end" placeholder="请选择受单日期" ></DatePicker>
            </FormItem>
          </Col>
          <Col span="6">
            <FormItem label="实际到厂日期:" style="width: 100%">
              <DatePicker v-model="rangeTimeSJDCRQ" type="daterange" format="yyyy-MM-dd" style="width: 100%" placement="bottom-end" placeholder="请选择实际到厂日期" ></DatePicker>
            </FormItem>
          </Col>
        </Row>
        <Row :gutter="16">
          <!-- <Col span="8">
            <FormItem label="类别:">
              <Input v-model="query.Category" placeholder="请输入类别" ></Input>
            </FormItem>
          </Col> -->
          <Col span="8">
            <FormItem  label="类别:">
              <Select multiple placeholder="请选择类别" v-model="categoryArrary">
                <Option v-for="item in categoryList" :key="item" :value="item">{{ item }}</Option>
              </Select>
              <!-- <Checkbox v-model="query.ContainKBDCRQ">排除未到厂</Checkbox> -->
            </FormItem>
          </Col>
          
          <Col span="6">
            <FormItem label="要求到厂日期:" style="width: 100%">
              <DatePicker v-model="rangeTimeYQDCRQ" type="daterange" format="yyyy-MM-dd" style="width: 100%" placeholder="请选择要求到厂日期"></DatePicker>
            </FormItem>
          </Col>
          <Button icon="ios-search" type="primary" size="default" @click="getInit" class="toolbar-btn" >统计</Button>
          <Button @click="exportFile" icon="md-archive" type="primary" size="default" class="toolbar-btn" >{{ "导出" }}</Button >
        </Row>
      </Form>
      <div>
        <Table :columns="columns" no-data-text="暂无数据" border :data="list" ></Table>
      </div>
    </Card>
    <Spin fix v-show="loading">
      <Icon type="ios-loading" size="18" class="demo-spin-icon-load"></Icon>
      <div>加载中</div>
    </Spin>
  </div>
</template>

<script>
import moment from "moment";
import Util from "../../../lib/util";

export default {
  name: "statistics",
  data() {
    return {
      query: {
        Category:'',
        StartYQDCRQ: '',//要求到厂
        EndYQDCRQ: '',
        SupplierName: "",
        StartSDRQ: "",
        EndSDRQ: "",
        StartSJDCRQ: "",
        EndSJDCRQ: "",
      },
      categoryList:['低值易耗','标准件','主材料','加工件','数控加工','五金工具','表面处理'],
      rangeTimeSDRQ: [],
      categoryArrary:[],
      rangeTimeSJDCRQ: [],
      rangeTimeYQDCRQ: [],
      list: [],
      supplierSelectResult:[],
      supplierNameList:[],
      columns: [],
      options2:[],
      loading: false,
      loading2:false,
    };
  },
  mounted() {
    this.getNowDate();
    this.getColumns();
    this.getInit();
    this.getSupplierInit();
  },
  methods: {
    async getSupplierInit(){
      const supplierSelectResults = await this.$Ajax( "/api/services/app/GZBDataItem/SupplierListInit");
      this.supplierSelectResult = supplierSelectResults.data.result;
    },
    async getInit() {
      this.loading = true;
      if (this.rangeTimeSDRQ[0]) {
        this.query.StartSDRQ = moment(this.rangeTimeSDRQ[0]).format( "YYYY-MM-DD" );
      }
      if (this.rangeTimeSDRQ[1]) {
        this.query.EndSDRQ = moment(this.rangeTimeSDRQ[1]).format("YYYY-MM-DD");
      }
      if (!this.rangeTimeSDRQ[0]) {
        this.query.StartSDRQ = "";
      }
      if (!this.rangeTimeSDRQ[1]) {
        this.query.EndSDRQ = "";
      }
      if (this.rangeTimeSJDCRQ[0]) {
        this.query.StartSJDCRQ = moment(this.rangeTimeSJDCRQ[0]).format( "YYYY-MM-DD" );
      }
      if (this.rangeTimeSJDCRQ[1]) {
        this.query.EndSJDCRQ = moment(this.rangeTimeSJDCRQ[1]).format( "YYYY-MM-DD" );
      }
      if (!this.rangeTimeSJDCRQ[0]) {
        this.query.StartSJDCRQ = "";
      }
      if (!this.rangeTimeSJDCRQ[1]) {
        this.query.EndSJDCRQ = "";
      }
      //要求到厂日期
      if (this.rangeTimeYQDCRQ[0]) {
        this.query.StartYQDCRQ = moment(this.rangeTimeYQDCRQ[0]).format('YYYY-MM-DD')
      }
      if (this.rangeTimeYQDCRQ[1]) {
        this.query.EndYQDCRQ = moment(this.rangeTimeYQDCRQ[1]).format('YYYY-MM-DD')
      }
      if (!this.rangeTimeYQDCRQ[0]) {
        this.query.StartYQDCRQ = ''
      }
      if (!this.rangeTimeYQDCRQ[1]) {
        this.query.EndYQDCRQ = ''
      }

      this.categoryArrary.forEach(element => {
        this.query.Category += element +','
      });
      this.supplierNameList.forEach(element => {
        this.query.SupplierName += element +','
      });
      //console.log(this.query.SupplierName);
      const result = await this.$Ajax( "/api/services/app/GZBDataItem/GetSupplierDeliveryTimelyRate", { params: this.query } );
      this.list = result.data.result
      this.loading = false;
      this.query.Category = '';
      this.query.SupplierName = '';
    },
    remoteMethod(query) {
    if (query !== '') {
        this.loading2 = true;
        setTimeout(() => {
            this.loading2 = false;
            const list = this.supplierSelectResult.map(item => {
                return {
                    value: item,
                    label: item
                };
            });
            this.options2 = list.filter(item => item.label.toLowerCase().indexOf(query.toLowerCase()) > -1);
        }, 200);
    } else {
        this.options2 = [];
      }   
    },
    getNowDate(){
      const date = new Date()
      const year = date.getFullYear()
      const month = date.getMonth()
      this.rangeTimeSDRQ = [new Date(year,month,1),new Date()]
    },
    getColumns() {
      this.columns =[
        {
          title:'供应商名称',
          key:'supplierName'
        },
        {
          title:'供应商编码',
          key:'supplierCode'
        },
        {
          title:'按时交货数',
          key:'onTimeDeliveryNumber'
        },
        {
          title:'总交货数',
          key:'allDeliveryNumber'
        },
        {
          title:'交货及时率',
           render: (h, params) => {
            return h(
              "span",
              params.row.deliveryTimelyRate=='NaN'?'/':params.row.deliveryTimelyRate + "%"
            );
          }
        },
        {
          title:'已反馈数',
          key:'finishFeedbackNumber'
        },
        {
          title:'应反馈数',
          key:'shouldFeedbackNumber'
        },
        {
          title:'超时反馈数',
          key:'tiemoutFeedbackNumber'
        },
        {
          title:'反馈率',
           render: (h, params) => {
            return h(
              "span",
              params.row.feedbackRate=='NaN'?'/':params.row.feedbackRate + "%"
            );
          }
        },
        {
          title:'超时反馈率',
           render: (h, params) => {
            return h(
              "span",
              params.row.timeoutFeedbackRate=='NaN'?'/':params.row.timeoutFeedbackRate + "%"
            );
          }
        }
      ]
    },
    exportFile() {
      if (this.rangeTimeSDRQ[0]) {
        this.query.StartSDRQ = moment(this.rangeTimeSDRQ[0]).format(
          "YYYY-MM-DD"
        );
      }
      if (this.rangeTimeSDRQ[1]) {
        this.query.EndSDRQ = moment(this.rangeTimeSDRQ[1]).format("YYYY-MM-DD");
      }
      if (!this.rangeTimeSDRQ[0]) {
        this.query.StartSDRQ = "";
      }
      if (!this.rangeTimeSDRQ[1]) {
        this.query.EndSDRQ = "";
      }
      if (this.rangeTimeSJDCRQ[0]) {
        this.query.StartSJDCRQ = moment(this.rangeTimeSJDCRQ[0]).format(
          "YYYY-MM-DD"
        );
      }
      if (this.rangeTimeSJDCRQ[1]) {
        this.query.EndSJDCRQ = moment(this.rangeTimeSJDCRQ[1]).format(
          "YYYY-MM-DD"
        );
      }
      if (!this.rangeTimeSJDCRQ[0]) {
        this.query.StartSJDCRQ = "";
      }
      if (!this.rangeTimeSJDCRQ[1]) {
        this.query.EndSJDCRQ = "";
      }
      //要求到厂日期
      if (this.rangeTimeYQDCRQ[0]) {
        this.query.StartYQDCRQ = moment(this.rangeTimeYQDCRQ[0]).format('YYYY-MM-DD')
      }
      if (this.rangeTimeYQDCRQ[1]) {
        this.query.EndYQDCRQ = moment(this.rangeTimeYQDCRQ[1]).format('YYYY-MM-DD')
      }
      this.categoryArrary.forEach(element => {
        this.query.Category += element +','
      });
      this.supplierNameList.forEach(element => {
        this.query.SupplierName += element +','
      });
      const date = moment(new Date()).format("yyyyMMDDHHmm");

      let _this = this;
      let consturl = `${this.$constDefinition.baseUrl}/api/Export/ExportSupplierDeliveryTimelyRate?SupplierName=${this.query.SupplierName}&StartSDRQ=${this.query.StartSDRQ}&EndSDRQ=${this.query.EndSDRQ}&StartSJDCRQ=${this.query.StartSJDCRQ}&EndSJDCRQ=${this.query.EndSJDCRQ}&StartYQDCRQ=${this.query.StartYQDCRQ}&EndYQDCRQ=${this.query.EndYQDCRQ}&Category=${this.query.Category}`; //下载地址url
      var xhr = new XMLHttpRequest();
      xhr.open("get", consturl, true); // get、post都可
      xhr.responseType = "blob";
      xhr.setRequestHeader(
        "Authorization",
        `Bearer ${Util.abp.auth.getToken()}`
      ); //加请求头
      xhr.onload = function () {
        console.log(xhr);
        if (xhr.status == 200) {
          let blob = new Blob([this.response], {
            type: "application/vnd.ms-excel",
          });
          var a = document.createElement("a");
          var url = window.URL.createObjectURL(blob);
          a.href = url;
          a.download = `供应商交货及时率报表${date}.xlsx`; // 文件名
          if (xhr.readyState === 4) {
            _this.$Message.success({
              content: "下载成功",
            });
          }
        } else {
          _this.$Message.error({
            content: "下载失败",
          });
        }
        a.click();
        window.URL.revokeObjectURL(url);
      };
      xhr.send();
      this.query.Category = '';
      this.query.SupplierName = '';
    },
  }
  };
</script>

<style lang="less" scoped>
.app {
  min-width: 900px;
}

.demo-spin-icon-load {
  animation: ani-demo-spin 1s linear infinite;
}
@keyframes ani-demo-spin {
  from {
    transform: rotate(0deg);
  }
  50% {
    transform: rotate(180deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.demo-spin-col {
  height: 100px;
  position: relative;
  border: 1px solid #eee;
}

</style>
